<template>
  <div>
    <div class="section section--half-y-padding">
      <h2
        class="title title--2"
        data-test-id="title"
      >
        {{ content.ReconfirmPickupLocation.title }}
      </h2>
    </div>

    <img
      class="image no-spacing"
      :src="locationMapImgSrc"
      style="min-height: 175px; aspect-ratio: 2; background-color: var(--color-light-gray);"
      :alt="`${location.description} Map`"
      data-test-id="map-image"
    >

    <div
      class="section center"
      data-test-id="location-info"
    >
      <p class="title title--3 no-spacing">
        {{ location.description }}
      </p>
      <p>
        {{ location.address.line1.trim() }}<br>
        {{ location.address.city.trim() }},
        {{ location.address.state.trim() }}
        {{ location.address.postalCode.trim() }}
      </p>
    </div>

    <div class="section section--half-y-padding section--alt-background">
      <p
        class="center"
        data-test-id="confirmation-message"
      >
        {{ content.ReconfirmPickupLocation.description }}
      </p>
      <div class="flex flex-wrap gap spacing">
        <button
          class="button button--auto-width button--primary button--large button--outlined background-light grow shrink no-spacing"
          type="button"
          data-test-id="change-location-button"
          @click="$openModal('editOrderDetails', {}, {
            closeModal: 'confirmPickupLocation'
          })"
        >
          {{ content.ReconfirmPickupLocation.metadata.secondaryCta }}
        </button>
        <button
          class="button button--auto-width button--primary button--large grow shrink no-spacing"
          type="button"
          data-test-id="confirm-button"
          @click="$emit('confirm')"
        >
          {{ content.ReconfirmPickupLocation.metadata.primaryCta }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'ConfirmLocation',

    props: {
      location: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['merchant']),

      locationMapImgSrc() {
        const primaryColorHex = this.merchant.options.skinOptions.primaryColor.split('#')[1];
        const { line1, city, state, postalCode } = this.location.address;

        const params = new URLSearchParams({
          zoom: 15,
          scale: 2,
          size: '500x250',
          format: 'jpg',
          markers: `color:0x${primaryColorHex}|${[line1, city, state, postalCode].join(' ')}`
        });

        [
          'feature:poi.attraction|visibility:off',
          'feature:poi.business|visibility:off',
          'feature:poi.medical|visibility:off',
          'feature:poi.place_of_worship|visibility:off',
          'feature:poi.school|visibility:off',
          'feature:poi.sports_complex|visibility:off',
          'feature:transit|visibility:off',
          'feature:water|geometry.fill|color:0x85BFFA'
        ].forEach(style => params.append('style', style));

        return `/google-api/static-map?${params.toString()}`;
      }
    }
  };
</script>
